import { render, staticRenderFns } from "./Saichang.vue?vue&type=template&id=54e706ea&scoped=true&"
import script from "./Saichang.vue?vue&type=script&lang=js&"
export * from "./Saichang.vue?vue&type=script&lang=js&"
import style0 from "./Saichang.vue?vue&type=style&index=0&id=54e706ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e706ea",
  null
  
)

export default component.exports